module.exports = {
  be: {
    authorised: 'Wat is een geautoriseerde dealer?',
    directions: 'Routebeschrijving',
    continue: 'Verder winkelen',
    listHeader: 'Winkel op de kaart',
    listHeaderMult: 'Winkels op de kaart',
    matrix: 'km',
    myPosition: 'Mijn locatie',
    search: 'Zoek op land, provincie, plaats, adres, postcode, …',
    closed: 'Gesloten',
    showIpad: 'Weergeven op kaart',
    monFri: 'ma - vrij',
    sat: 'zat',
    sun: 'zon',
    legalH1: 'GEAUTORISEERDE DEALERS',
    legalH2: 'WAAROM KOPEN BIJ EEN GEAUTORISEERDE DEALER?',
    legalL1: 'U koopt een origineel Daniel Wellington-horloge',
    legalL2: 'Uw horloge wordt gedekt door de internationale garantie van Daniel Wellington',
    legalL3: 'Onderhoud of reparatie wordt door ervaren medewerkers uitgevoerd',
    legalL4: 'U geniet van het hoogste niveau aan klantenservice',
    legalP1: 'Bij Daniel Wellington willen we ervoor zorgen dat u een uitstekende ervaring hebt met onze producten voor, tijdens en na uw aankoop. We werken exclusief met een selecte groep partners over de hele wereld die het privilege verdiend hebben een geautoriseerde dealer van Daniel Wellington te worden.',
    legalP2: 'Of u nu bij een winkel of online koopt, wij willen dat u een ervaring hebt die niets te wensen overlaat. Onze retailpartners hebben aan ons bewezen dat ze zich toeleggen op het leveren van een consistent uitstekend serviceniveau.',
    legalP3: 'De enige manier om te zorgen dat u een origineel Daniel Wellington-horloge koopt, is via een geautoriseerde dealer of via danielwellington.com.',
    legalP4: 'Wanneer u een horloge koopt bij een geautoriseerde dealer van Daniel Wellington, weet u het volgende zeker:',
    legalP5: 'Als je koopt op e-commerce platforms zoals eBay en Groupon of bij een niet-gemachtigde derde verkoper op Amazon, loop je het risico dat het horloge namaak, gebruikt of defect is. Daniel Wellington gaat niet in op garantieclaims die niet vergezeld gaan van de originele documentatie.',
    legalP6: 'Voor meer informatie en om een geautoriseerde dealer in uw regio te zoeken, gaat u naar www.danielwellington.com/authorized-retailers'
  },
  ch: {
    authorised: 'Was ist ein autorisierter Händler?',
    directions: 'Anfahrt',
    continue: 'Einkauf fortsetzen',
    listHeader: 'Geschäft auf der Karte',
    listHeaderMult: 'Geschäfte auf der Karte',
    matrix: 'km',
    myPosition: 'Mein Standort',
    search: 'Nach Land, Bundesland, Stadt, Adresse, Postleitzahl suchen ...',
    closed: 'Geschlossen',
    showIpad: 'Auf Karte anzeigen',
    monFri: 'Mo. - Fr.',
    sat: 'Sa.',
    sun: 'So.',
    legalH1: 'AUTORISIERTE EINZELHÄNDLER',
    legalH2: 'WARUM VON EINEM AUTORISIERTEN EINZELHÄNDLER KAUFEN?',
    legalL1: 'Sie einen echten Daniel Wellington-Zeitmesser kaufen,',
    legalL2: 'Ihre Armbanduhr von Daniel Wellingtons internationaler Garantie gedeckt wird,',
    legalL3: 'jeglicher Service oder Reparatur von erfahrenem Personal durchgeführt wird,',
    legalL4: 'Sie einen Kundenservice von höchstem Niveau erfahren.',
    legalP1: 'Wir bei Daniel Wellington wollen sichergehen, dass Ihr Erlebnis mit unseren Produkten erstklassig ist, und zwar vor, während und nach Ihrem Einkauf. Wir arbeiten rund um die Welt exklusiv mit einer ausgewählten Gruppe an Partnern zusammen, die sich das Privileg verdient haben, autorisierte Einzelhändler von Daniel Wellington zu sein.',
    legalP2: 'Egal ob Sie in einem Einzelhandelsgeschäft oder online einkaufen, wir möchten, dass dieses Erlebnis Sie vollkommen zufriedenstellt. Unsere Einzelhandelspartner haben uns bewiesen, dass sie sich einem gleichbleibend hervorragenden Kundenservice verpflichtet haben.',
    legalP3: 'Der einzige Weg zu gewährleisten, dass Sie eine echte Daniel Wellington-Armbanduhr kaufen, ist, sie von einem autorisierten Einzelhändler oder auf danielwellington.com zu erwerben.',
    legalP4: 'Wenn Sie eine Uhr durch einen autorisierten Einzelhändler von Daniel Wellington kaufen, können Sie versichert sein, dass:',
    legalP5: 'Wenn Sie von Internethandel-Plattformen wie eBay und Groupon oder von einem nicht autorisierten Drittanbieter auf Amazon kaufen, besteht ein Risiko, dass Sie einen Zeitmesser erhalten, der gefälscht, gebraucht oder defekt ist. Daniel Wellington übernimmt keine Garantie, sofern nicht die Kaufbelege im Original vorgelegt werden.',
    legalP6: 'Für weitere Informationen und um einen autorisierten Händler oder Einzelhändler in Ihrer Gegend zu finden, besuchen Sie bitte www.danielwellington.com/authorized-retailers'
  },
  cn: {
    authorised: '什麼是授權零售商？',
    directions: '規劃路線',
    continue: '繼續購物',
    listHeader: '地圖上顯示的實體店',
    listHeaderMult: '地圖上顯示的實體店',
    matrix: 'km',
    myPosition: '我的位置',
    search: '按照國家、州、城市、地址、郵編進行搜索…… ',
    closed: '已關閉',
    showIpad: '在地圖上顯示p',
    monFri: '週一到週五',
    sat: '週六',
    sun: '週日',
    legalH1: '授权零售商',
    legalH2: '为什么从授权零售商处购买产品？',
    legalL1: '您所购买的手表为正宗的 Daniel Wellington 手表',
    legalL2: '您的手表将可获得 Daniel Wellington 国际联保服务',
    legalL3: '所有服务和维修人员均经验丰富',
    legalL4: '您将获得最棒的客户服务体验',
    legalP1: '在 Daniel Wellington，我们希望确保您在购买产品时，能享受到无与伦比的售前、售中及售后体验。我们还在世界各地精心挑选了可靠的合作伙伴，指定其为 Daniel Wellington 授权零售商。',
    legalP2: '无论是在零售店，还是网上商店，我们都希望您能获得愉快的体验。我们的零售合作伙伴也证明了它们始终致力于提供持续卓越服务的承诺。',
    legalP3: '购买正宗 Daniel Wellington 手表的惟一途径便是通过授权零售商，或前往 danielwellington.com 网店购买。',
    legalP4: '当您从 Daniel Wellington 授权零售商处购买手表时，您可获得以下保证：',
    legalP5: '如果您从 Amazon、eBay 或 Groupon 等非授权零售商处购买手表，则您收到的手表可能是仿冒产品、二手产品或缺陷产品。对于无法提供原始文件的索赔，Daniel Wellington 不予理赔。',
    legalP6: '如需了解更多信息，寻找您当地的授权经销商或零售商，请访问：www.danielwellington.com/authorized-retailers'
  },
  cz: {
    authorised: 'Co znamená „autorizovaný prodejce“?',
    directions: 'Získejte pokyny',
    continue: 'Pokračovat v nákupu',
    listHeader: 'Prodejna na mapě',
    listHeaderMult: 'Prodejny na mapě',
    matrix: 'km',
    myPosition: 'Moje poloha',
    search: 'Vyhledávání podle země, města, adresy, směrovacího čísla...',
    closed: 'Zavřeno',
    showIpad: 'Ukázat na mapě',
    monFri: 'Pondělí - Pátek',
    sat: 'Sobota',
    sun: 'Neděle',
    legalH1: 'AUTORIZOVANÍ PRODEJCI',
    legalH2: 'PROČ NAKUPOVAT U AUTORIZOVANÝCH PRODEJCŮ',
    legalL1: 'Kupujete pravé hodinky značky Daniel Wellington.',
    legalL2: 'Vaše hodinky mají mezinárodní záruku poskytovanou společností Daniel Wellington.',
    legalL3: 'Všechny služby a opravy provádějí zkušení pracovníci.',
    legalL4: 'Získáte maximální úroveň zákaznické podpory.',
    legalP1: 'Naším přáním u společnosti Daniel Wellington je zajistit, aby byla vaše zkušenost s našimi výrobky vynikající před jejich zakoupením, ale i během nákupu a po něm. Pracujeme výhradně s vybranou skupinou partnerů po celém světě, kteří získali oprávnění být autorizovanými prodejci společnosti Daniel Wellington.',
    legalP2: 'Ať už nakupujete v prodejně nebo na e-shopu, chceme vám poskytnout takový zážitek, jaký vás zcela uspokojí. Naši obchodní partneři nám dokázali, že jsou odhodláni poskytovat trvale vynikající úroveň služeb.',
    legalP3: 'Jediným způsobem, jak zajistit, že si koupíte pravé hodinky značky Daniel Wellington, je zakoupit si je prostřednictvím autorizovaného prodejce nebo na adrese danielwellington.com.',
    legalP4: 'Pokud hodinky zakoupíte u autorizovaného prodejce společnosti Daniel Wellington, můžete se spolehnout, že:',
    legalP5: 'Pokud nakupujete na e-shopech, jako je například eBay a Groupon, nebo od neautorizovaného prodejce třetí strany v obchodě Amazon, vyvstává riziko zakoupení padělaných, použitých nebo vadných hodinek. Společnost Daniel Wellington nebude brát ohled na žádné žádosti o reklamaci, které nebudou dodány společně s původní dokumentací.',
    legalP6: 'Více informací a způsob vyhledání autorizovaného prodejce ve vašem okolí získáte na webové stránce www.danielwellington.com/authorized-retailers'
  },
  dk: {
    authorised: 'Hvad er en autoriseret forhandler?',
    directions: 'Få anvisninger',
    continue: 'Fortsæt med at shoppe',
    listHeader: 'Butik vist på kort',
    listHeaderMult: 'Butikker vist på kort',
    matrix: 'km',
    myPosition: 'Min placering',
    search: 'Søg efter land, stat, by, adresse, postnummer...',
    closed: 'Lukket',
    showIpad: 'Vist på kort',
    monFri: 'Man - Fre',
    sat: 'Lør',
    sun: 'Søn',
    legalH1: 'AUTORISEREDE FORHANDLERE',
    legalH2: 'HVORFOR KØBE HOS EN AUTORISERET FORHANDLER?',
    legalL1: 'Du køber et ægte Daniel Wellington ur',
    legalL2: 'Dit ur vil være dækket af Daniel Wellingtons internationale garanti',
    legalL3: 'Alle serviceydelser og reparationer vil blive udført af erfarne medarbejdere',
    legalL4: 'Du vil få den bedst mulige kundeservice',
    legalP1: 'Hos Daniel Wellington vil vi gerne være sikre på, at du får en enestående oplevelse med vores produkter både før, under og efter dit køb. Vi samarbejder kun med en udvalgt gruppe af partnere i hele verden, der har opnået det privilegium at være autoriserede Daniel Wellington-forhandlere.',
    legalP2: 'Uanset om du handler i en butik eller online, er det vores ønske, at du får en oplevelse, du kan være fuldstændig tilfreds med. Vores partnere i detailhandelen har bevist overfor os, at de ønsker at levere et fremragende og vedvarende serviceniveau.',
    legalP3: 'Den eneste måde, du kan være sikker på at købe et ægte Daniel Wellington ur, er at købe det hos en autoriseret forhandler eller hos danielwellington.com.',
    legalP4: 'Når du køber et ur hos en autoriseret Daniel Wellington-forhandler, kan du være sikker på, at:',
    legalP5: 'Hvis du handler på nettet hos udbydere som eBay og Groupon eller en uautoriseret tredjepartsforhandler på Amazon, er der risiko for at modtage et ur, der er en efterligning, brugt eller defekt. Daniel Wellington imødekommer ikke garantikrav, der ikke er ledsaget af den originale dokumentation.',
    legalP6: 'Besøg www.danielWellington.com/autoriserede forhandlere for at få flere oplysninger og finde en autoriseret forhandler i dit område.'
  },
  en: {
    authorised: 'What is an Authorised retailer?',
    directions: 'Get directions',
    continue: 'Continue Shopping',
    listHeader: 'Store shown on map',
    listHeaderMult: 'Stores shown on map',
    matrix: 'km',
    myPosition: 'My position',
    search: 'Search by country, state, city, address, zip code...',
    closed: 'Closed',
    showIpad: 'Show on map',
    monFri: 'Mon - Fri',
    sat: 'Sat',
    sun: 'Sun',
    legalH1: 'AUTHORIZED RETAILERS',
    legalH2: 'WHY BUY FROM AN AUTHORIZED RETAILER?',
    legalL1: 'You are buying an authentic Daniel Wellington timepiece',
    legalL2: 'Your watch will be covered by Daniel Wellington’s international warranty',
    legalL3: 'Any service or repair will be conducted by experienced personnel',
    legalL4: 'You will experience the highest level of customer service',
    legalP1: 'At Daniel Wellington, we want to ensure that your experience with our products is outstanding, before, during and after your purchase. We work exclusively with a select group of partners around the world who have earned the privilege of being an authorized Daniel Wellington retailer.',
    legalP2: 'Whether you purchase from a retail store or online, we want you to have an experience that leaves you completely satisfied. Our retail partners have proven to us that they are committed to delivering a consistently excellent level of service.',
    legalP3: 'The only way to ensure you are buying an authentic Daniel Wellington watch is to purchase it through an authorized retailer or at danielwellington.com.',
    legalP4: 'When you purchase a watch from an authorized Daniel Wellington retailer, you can be assured that:',
    legalP5: 'If purchasing from e commerce platforms such as eBay and Groupon or an unauthorized third party vendor on Amazon, there is a risk of receiving a timepiece that is counterfeit, used or defective. Daniel Wellington does not honor any warranty claims that are not accompanied by the original documentation.',
    legalP6: 'For more information and to find an authorized dealer or retailer in your area, please visit www.danielwellington.com/authorized-retailers'
  },
  es: {
    authorised: '¿Qué es un distribuidor autorizado?',
    directions: 'Infórmate sobre cómo llegar',
    continue: 'Seguir comprando',
    listHeader: 'Tienda mostrada en el mapa',
    listHeaderMult: 'Tiendas mostradas en el mapa',
    matrix: 'km',
    myPosition: 'Mi posición',
    search: 'Búsqueda por país, estado, ciudad, dirección, código postal...',
    closed: 'Cerrado',
    showIpad: 'Mostrar en el mapa',
    monFri: 'Lun. - Vie.',
    sat: 'Sáb.',
    sun: 'Dom.',
    legalH1: 'DISTRIBUIDORES AUTORIZADOS',
    legalH2: 'MOTIVOS PARA COMPRAR EN UN DISTRIBUIDOR AUTORIZADO',
    legalL1: 'Está comprando un reloj auténtico de Daniel Wellington',
    legalL2: 'Su reloj quedará cubierto por la garantía internacional de Daniel Wellington',
    legalL3: 'Cualquier reparación o servicio será realizado por personal experimentado',
    legalL4: 'Disfrutará de un servicio a clientes del máximo nivel',
    legalP1: 'En Daniel Wellington, queremos estar seguros de que disfruta de una experiencia extraordinaria con nuestros productos antes, durante y después de la compra. Trabajamos exclusivamente con un grupo de socios seleccionados que se han ganado el privilegio de ser distribuidores autorizados de Daniel Wellington.',
    legalP2: 'Independientemente de que realice su compra en un punto de venta o en Internet, queremos que la experiencia sea de su total satisfacción. Nuestros socios minoristas nos han demostrado su compromiso para ofrecer siempre un servicio excelente.',
    legalP3: 'El único modo de estar seguro de comprar un reloj auténtico de Daniel Wellington es hacerlo a través de un distribuidor autorizado o bien, en danielwellington.com.',
    legalP4: 'Si compra un reloj en un distribuidor autorizado de Daniel Wellington, podrá estar seguro de que:',
    legalP5: 'Al realizar tu compra en plataformas de comercio electrónico tales como eBay y Groupon o bien, en distribuidores no autorizados en Amazon, existe el riesgo de que recibas un reloj falso, usado o defectuoso. Daniel Wellington no atenderá reclamaciones de garantía que no se presenten acompañadas de la documentación original.',
    legalP6: 'Si desea obtener más información o buscar un minorista o distribuidor autorizado en su zona, visite www.danielwellington.com/authorized-retailers'
  },
  fi: {
    authorised: 'Mikä on valtuutettu jälleenmyyjä?',
    directions: 'Ajo-ohjeet',
    continue: 'Jatka ostoksia',
    listHeader: 'Myymälä kartalla',
    listHeaderMult: 'Myymälät kartalla',
    matrix: 'km',
    myPosition: 'Oma sijaintini',
    search: 'Hae esimerkiksi maan, osavaltion, paikkakunnan, katuosoitteen tai postinumeron perusteella',
    closed: 'Suljettu',
    showIpad: 'Näytä kartalla',
    monFri: 'Ma – pe',
    sat: 'La',
    sun: 'Su',
    legalH1: 'VALTUUTETUT JÄLLEENMYYJÄT',
    legalH2: 'MIKSI KANNATTAA OSTAA VALTUUTETULTA JÄLLEENMYYJÄLTÄ?',
    legalL1: 'Olet ostamassa aitoa Daniel Wellington -kelloa',
    legalL2: 'Saat kellollesi Daniel Wellingtonin kansainvälisen takuun',
    legalL3: 'Huollot tai korjaukset suorittaa kokenut henkilöstö',
    legalL4: 'Saat parasta mahdollista asiakaspalvelua',
    legalP1: 'Haluamme Daniel Wellingtonilla varmistaa, että saat ainutlaatuisen kokemuksen tuotteistamme ennen niiden ostamista, ostotilanteessa ja ostamisen jälkeen. Työskentelemme eri puolilla maailmaa ainoastaan niiden valittujen jälleenmyyjien kanssa, jotka ovat ansainneet etuoikeuden toimia valtuutettuina Daniel Wellington -jälleenmyyjinä.',
    legalP2: 'Hankitpa kellon myymälästä tai verkkokaupasta, haluamme tarjota kokemuksen, johon olet täysin tyytyväinen. Jälleenmyyjäkumppanimme ovat todistaneet meille, että he ovat sitoutuneet toimittamaan jatkuvasti erinomaista palvelua.',
    legalP3: 'Ainoa tapa varmistaa, että ostat aidon Daniel Wellington -kellon on ostaa se valtuutetulta jälleenmyyjältä tai verkkokaupasta danielwellington.com.',
    legalP4: 'Ostaessasi kellon valtuutetulta Daniel Wellington -jälleenmyyjältä voit olla varma, että:',
    legalP5: 'Jos ostat verkkokauppapalvelusta, kuten eBaysta ja Grouponista tai valtuuttamattomalta kolmannen osapuolen myyjältä Amazonista, saatat saada kellon, joka on väärennös, käytetty tai viallinen. Daniel Wellington ei vastaa takuupyynnöistä, joiden mukana ei ole alkuperäistä todistusta.',
    legalP6: 'Katso lisätietoja ja etsi alueesi valtuutettu välittäjä tai jälleenmyyjä osoitteesta www.danielwellington.com/authorized-retailers'
  },
  fr: {
    authorised: 'Qu’est-ce qu’un revendeur agréé ?',
    directions: 'Obtenir un itinéraire',
    continue: 'Continuer mes achats',
    listHeader: 'Indiquer la boutique sur la carte',
    listHeaderMult: 'Indiquer les boutiques sur la carte',
    matrix: 'km',
    myPosition: 'Ma position',
    search: 'Recherche par pays, état, ville, adresse, code postal...',
    closed: 'Fermé',
    showIpad: 'Afficher sur la cartep',
    monFri: 'Lun - Ven',
    sat: 'Sam.',
    sun: 'Dim.',
    legalH1: 'REVENDEURS AGRÉÉS',
    legalH2: 'POURQUOI ACHETER AUPRÈS D\'UN REVENDEUR AGRÉÉ ?',
    legalL1: 'D’acheter une montre Daniel Wellington authentique',
    legalL2: 'Que votre montre sera couverte par la garantie internationale de Daniel Wellington',
    legalL3: 'Que les entretiens et réparations seront réalisés par du personnel expérimenté',
    legalL4: 'Que vous bénéficierez d\'une qualité de service clientèle exceptionnelle',
    legalP1: 'Chez Daniel Wellington, nous voulons nous assurer de vous proposer une expérience exceptionnelle de nos produits – avant, pendant et après votre achat. Nous travaillons exclusivement avec un groupe de partenaires choisis, présents dans le monde entier, qui ont mérité le privilège d\'être un revendeur agréé de Daniel Wellington.',
    legalP2: 'Peu importe que vous fassiez vos achats dans un magasin ou en ligne, nous voulons vous proposer une expérience qui vous apporte une satisfaction totale. Nos partenaires revendeurs nous ont démontré qu\'ils s’engagent à offrir une qualité de service constamment excellente.',
    legalP3: 'La seule manière de vous assurer d’acheter une montre Daniel Wellington authentique est de l’acheter auprès d\'un revendeur agréé ou sur danielwellington.com.',
    legalP4: 'Lorsque vous achetez une montre auprès d\'un revendeur agréé de Daniel Wellington, vous avez l’assurance :',
    legalP5: 'Si vous effectuez votre achat sur une plate-forme de commerce en ligne telle qu’eBay ou Groupon ou auprès d’un revendeur tiers non agréé sur Amazon, vous courez le risque de recevoir une montre contrefaite, d’occasion ou défectueuse. Daniel Wellington n’honorera aucune réclamation au titre de la garantie si elle n’est pas accompagnée de la documentation d’origine.',
    legalP6: 'Pour plus d\'informations et pour localiser un revendeur ou un détaillant agréé dans votre région, veuillez consulter la page www.danielwellington.com/authorized-retailers'
  },
  hr: {
    authorised: 'Što je „ovlašteni trgovac”?',
    directions: 'Dobijte upute',
    continue: 'Nastavak kupnje',
    listHeader: 'Trgovina prikazana na karti',
    listHeaderMult: 'Trgovine prikazane na karti',
    matrix: 'km',
    myPosition: 'Moja pozicija',
    search: 'Pretraživanje po državi, gradu, adresi, poštanskom broju...',
    closed: 'Zatvoreno',
    showIpad: 'Prikaži na karti',
    monFri: 'Pon. – pet.',
    sat: 'Sub.',
    sun: 'Ned.',
    legalH1: 'OVLAŠTENI TRGOVCI',
    legalH2: 'ZAŠTO KUPOVATI KOD OVLAŠTENOG TRGOVCA?',
    legalL1: 'Kupujete autentični sat marke Daniel Wellington',
    legalL2: 'Za svoj ćete sat dobiti međunarodno jamstvo poduzeća Daniel Wellington',
    legalL3: 'Sve servise i popravke obavit će iskusni djelatnici',
    legalL4: 'Doživjet ćete najvišu razinu usluge prema korisnicima',
    legalP1: 'U poduzeću Daniel Wellington želimo biti sigurni da će vam naši proizvodi pružiti izvanredan doživljaj prije, tijekom i nakon kupnje. Surađujemo isključivo s odabranom skupinom partnera diljem svijeta koji su zaslužili pravo da postanu ovlašteni trgovci proizvoda Daniel Wellington.',
    legalP2: 'Želimo vam pružiti doživljaj kojim ćete biti potpuno zadovoljni, bez obzira na to kupujete li u maloprodajnoj trgovini ili putem interneta. Naši maloprodajni partneri dokazali su nam da se trude pružiti dosljedno izvrsnu razinu usluge.',
    legalP3: 'Jedini način da budete sigurni kako ste kupili autentični sat Daniel Wellington jest to da ga kupite putem ovlaštenog trgovca ili na stranici danielwellington.com.',
    legalP4: 'Kada kupite sat od ovlaštenog trgovca proizvoda Daniel Wellington, možete biti sigurni u sljedeće:',
    legalP5: 'Ako kupnju obavite putem platformi za e-trgovinu kao što su eBay i Groupon ili kod neovlaštenog nezavisnog trgovca na Amazonu, postoji opasnost da ćete dobiti sat koji je krivotvoren, rabljen ili neispravan. Daniel Wellington neće prihvatiti zahtjeve na temelju jamstva ako oni nisu popraćeni originalnom dokumentacijom.',
    legalP6: 'Želite li više informacija ili pronaći obližnjeg ovlaštenog distributera ili trgovca, posjetite stranicu www.danielwellington.com/authorized-retailers'
  },
  id: {
    authorised: 'Apa yang dimaksud dengan pengecer resmi?',
    directions: 'Tampilkan arah',
    continue: 'Teruskan Belanja',
    listHeader: 'Toko yang ada di peta',
    listHeaderMult: 'Toko-toko yang ada di peta',
    matrix: 'km',
    myPosition: 'Posisi saya',
    search: 'Cari berdasarkan negara, negara bagian, kota, alamat, kode pos…',
    closed: 'Tutup',
    showIpad: 'Tampilkan di peta',
    monFri: 'Sen - Jum',
    sat: 'Sab',
    sun: 'Min',
  },
  ie: {
    authorised: 'What is an Authorised retailer?',
    directions: 'Get directions',
    continue: 'Continue Shopping',
    listHeader: 'Store shown on map',
    listHeaderMult: 'Stores shown on map',
    matrix: 'km',
    myPosition: 'My position',
    search: 'Search by country, state, city, address, zip code...',
    closed: 'Closed',
    showIpad: 'Show on map',
    monFri: 'Mon - Fri',
    sat: 'Sat',
    sun: 'Sun',
    legalH1: 'AUTHORIZED RETAILERS',
    legalH2: 'WHY BUY FROM AN AUTHORIZED RETAILER?',
    legalL1: 'You are buying an authentic Daniel Wellington timepiece',
    legalL2: 'Your watch will be covered by Daniel Wellington’s international warranty',
    legalL3: 'Any service or repair will be conducted by experienced personnel',
    legalL4: 'You will experience the highest level of customer service',
    legalP1: 'At Daniel Wellington, we want to ensure that your experience with our products is outstanding, before, during and after your purchase. We work exclusively with a select group of partners around the world who have earned the privilege of being an authorized Daniel Wellington retailer.',
    legalP2: 'Whether you purchase from a retail store or online, we want you to have an experience that leaves you completely satisfied. Our retail partners have proven to us that they are committed to delivering a consistently excellent level of service.',
    legalP3: 'The only way to ensure you are buying an authentic Daniel Wellington watch is to purchase it through an authorized retailer or at danielwellington.com.',
    legalP4: 'When you purchase a watch from an authorized Daniel Wellington retailer, you can be assured that:',
    legalP5: 'If purchasing from e commerce platforms such as eBay and Groupon or an unauthorized third party vendor on Amazon, there is a risk of receiving a timepiece that is counterfeit, used or defective. Daniel Wellington does not honor any warranty claims that are not accompanied by the original documentation.',
    legalP6: 'For more information and to find an authorized dealer or retailer in your area, please visit www.danielwellington.com/authorized-retailers'
  },
  it: {
    authorised: 'Che cos\'è un rivenditore autorizzato?',
    directions: 'Indicazioni stradali',
    continue: 'Continua ad acquistare',
    listHeader: 'Negozio visualizzato sulla mappa',
    listHeaderMult: 'Negozi visualizzati sulla mappa',
    matrix: 'km',
    myPosition: 'La mia posizione',
    search: 'Cerca per paese, stato, città, indirizzo, C.A.P …',
    closed: 'Chiuso',
    showIpad: 'Mostra sulla mappa',
    monFri: 'Lun - Ven',
    sat: 'Sab',
    sun: 'Dom',
    legalH1: 'RIVENDITORI AUTORIZZATI',
    legalH2: 'PERCHÉ ACQUISTARE DA UN RIVENDITORE AUTORIZZATO?',
    legalL1: 'state acquistando un orologio Daniel Wellington autentico',
    legalL2: 'l’orologio è coperto dalla garanzia internazionale di Daniel Wellington',
    legalL3: 'qualunque intervento di assistenza o riparazione sarà eseguito da personale qualificato',
    legalL4: 'sperimenterete il massimo livello di assistenza ai clienti',
    legalP1: 'Alla Daniel Wellington vogliamo essere sicuri che la vostra esperienza con i nostri prodotti sia eccellente, prima, durante e dopo l’acquisto. Lavoriamo esclusivamente con un gruppo selezionato di partner in tutto il mondo che hanno acquisito il privilegio di essere rivenditori autorizzati Daniel Wellington.',
    legalP2: 'Sia che l’acquisto venga effettuato presso un negozio oppure online, vogliamo offrirvi un’esperienza che vi lasci completamente soddisfatti. I nostri rivenditori ci hanno dimostrato il loro impegno nell’offrire un livello di assistenza sempre eccellente.',
    legalP3: 'L’unico modo per essere sicuri di stare acquistando un orologio Daniel Wellington autentico è quello di acquistarlo tramite un rivenditore autorizzato o su danielwellington.com.',
    legalP4: 'Quando acquistate un orologio da un rivenditore autorizzato Daniel Wellington, possiamo garantirvi che:',
    legalP5: 'Se si acquista da piattaforme e-commerce come eBay e Groupon o da un fornitore esterno non autorizzato su Amazon, si corre il rischio di ricevere un orologio falso, usato o difettoso. Daniel Wellington non onorerà alcuna richiesta di intervento in garanzia non accompagnata dalla documentazione originale.',
    legalP6: 'Per maggiori informazioni o per trovare un distributore o rivenditore autorizzato nella propria zona, visitare il sito www.danielwellington.com/rivenditori-autorizzati'
  },
  jp: {
    authorised: '正規販売店とは？',
    directions: '道順を表示する',
    continue: '買い物を続ける',
    listHeader: 'ストアを地図上で表示しています',
    listHeaderMult: 'ストアを地図上で表示しています',
    matrix: 'km',
    myPosition: 'あなたの場所',
    search: '国、州、市、住所、郵便番号等で検索',
    closed: '営業時間外',
    showIpad: '地図上で表示',
    monFri: '月曜 - 金曜',
    sat: '土曜',
    sun: '日曜',
    legalH1: '正規販売店について',
    legalH2: '正規販売店でのご購入をおすすめする理由',
    legalL1: 'ダニエル・ウェリントンの正規品のタイムピースのご購入',
    legalL2: 'ご購入いただいた時計はダニエル・ウェリントンの国際保証対象',
    legalL3: '熟練した担当者・技術者によるサービスまたは修理',
    legalL4: 'きめ細かなカスタマーサービス',
    legalP1: 'ダニエル・ウェリントンでは、ご購入前、ご購入時、またご購入後に至るまで、製品について心からご満足いただきたいと考えております。ダニエル・ウェリントンが販売を委託しているのは、正規取扱店として特別に認定した、世界中の選ばれたパートナーグループだけです。',
    legalP2: '小売店またはオンラインのいずれでご購入になる場合でも、心から満足したと実感していただくことが私たちの願いです。ダニエル・ウェリントンの販売パートナーは、弊社との契約において、高いレベルでお客様にサービスをご提供し続けることをお約束しています。',
    legalP3: '確実にダニエル・ウェリントンの正規品の腕時計をお買い求めいただけるのは、正規販売店またはdanielwellington.comのみです。',
    legalP4: 'ダニエル・ウェリントン正規販売店で腕時計をご購入いただくと、次のことが保証されます。',
    legalP5: 'eBay、Groupon、またはAmazonの正規販売店以外の第三者ベンダーでご購入の場合、模造品や中古品、欠陥品であるリスクを伴います。 ダニエル・ウェリントンでは、正規品であることを証明する書類のない場合の保証のご請求にはご対応致しかねます。',
    legalP6: '詳細、ならびにお近くの正規販売店または正規ディーラーについては、www.danielwellington.com/authorized-retailersでご確認ください。'
  },
  de: {
    authorised: 'Was ist ein autorisierter Händler?',
    directions: 'Anfahrt',
    continue: 'Einkauf fortsetzen',
    listHeader: 'Geschäft auf der Karte',
    listHeaderMult: 'Geschäfte auf der Karte',
    matrix: 'km',
    myPosition: 'Mein Standort',
    search: 'Nach Land, Bundesland, Stadt, Adresse, Postleitzahl suchen ...',
    closed: 'Geschlossen',
    showIpad: 'Auf Karte anzeigen',
    monFri: 'Mo. - Fr.',
    sat: 'Sa.',
    sun: 'So.',
    legalH1: 'AUTORISIERTE EINZELHÄNDLER',
    legalH2: 'WARUM VON EINEM AUTORISIERTEN EINZELHÄNDLER KAUFEN?',
    legalL1: 'Sie einen echten Daniel Wellington-Zeitmesser kaufen,',
    legalL2: 'Ihre Armbanduhr von Daniel Wellingtons internationaler Garantie gedeckt wird,',
    legalL3: 'jeglicher Service oder Reparatur von erfahrenem Personal durchgeführt wird,',
    legalL4: 'Sie einen Kundenservice von höchstem Niveau erfahren.',
    legalP1: 'Wir bei Daniel Wellington wollen sichergehen, dass Ihr Erlebnis mit unseren Produkten erstklassig ist, und zwar vor, während und nach Ihrem Einkauf. Wir arbeiten rund um die Welt exklusiv mit einer ausgewählten Gruppe an Partnern zusammen, die sich das Privileg verdient haben, autorisierte Einzelhändler von Daniel Wellington zu sein.',
    legalP2: 'Egal ob Sie in einem Einzelhandelsgeschäft oder online einkaufen, wir möchten, dass dieses Erlebnis Sie vollkommen zufriedenstellt. Unsere Einzelhandelspartner haben uns bewiesen, dass sie sich einem gleichbleibend hervorragenden Kundenservice verpflichtet haben.',
    legalP3: 'Der einzige Weg zu gewährleisten, dass Sie eine echte Daniel Wellington-Armbanduhr kaufen, ist, sie von einem autorisierten Einzelhändler oder auf danielwellington.com zu erwerben.',
    legalP4: 'Wenn Sie eine Uhr durch einen autorisierten Einzelhändler von Daniel Wellington kaufen, können Sie versichert sein, dass:',
    legalP5: 'Wenn Sie von Internethandel-Plattformen wie eBay und Groupon oder von einem nicht autorisierten Drittanbieter auf Amazon kaufen, besteht ein Risiko, dass Sie einen Zeitmesser erhalten, der gefälscht, gebraucht oder defekt ist. Daniel Wellington übernimmt keine Garantie, sofern nicht die Kaufbelege im Original vorgelegt werden.',
    legalP6: 'Für weitere Informationen und um einen autorisierten Händler oder Einzelhändler in Ihrer Gegend zu finden, besuchen Sie bitte www.danielwellington.com/authorized-retailers'
  },
  hk: {
    authorised: '什麼是授權零售商？',
    directions: '規劃路線',
    continue: '繼續購物',
    listHeader: '地圖上顯示的實體店',
    listHeaderMult: '地圖上顯示的實體店',
    matrix: 'km',
    myPosition: '我的位置',
    search: '按照國家、州、城市、地址、郵編進行搜索…… ',
    closed: '已關閉',
    showIpad: '在地圖上顯示',
    monFri: '週一到週五',
    sat: '週六',
    sun: '週日',
    legalH1: '授權經銷商',
    legalH2: '為何要向授權經銷商購買？',
    legalL1: '您買到的是 Daniel Wellington 原廠錶款',
    legalL2: '您的手錶可享有 Daniel Wellington 國際保固',
    legalL3: '服務或維修一律由經驗豐富的人員提供',
    legalL4: '您可以獲得最高品質的客戶服務',
    legalP1: 'Daniel Wellington 期許我們的產品能讓您無論在購買前、購買時及購買後都留下完美的印象。我們與一群在世界各地精心挑選的合作夥伴配合，他們就是 Daniel Wellington 授權經銷商。',
    legalP2: '無論您的購買途徑是零售店或網絡商店，我們都希望令您完全滿意。我們的經銷合作夥伴向我們證明了他們會努力提供穩定且卓越的服務水準。',
    legalP3: '透過授權經銷商或 danielwellington.com 購買，是能買到 Daniel Wellington 原廠手錶的唯一保證。',
    legalP4: '只要向 Daniel Wellington 授權經銷商購買手錶，就能享有下列保障：',
    legalP5: '從諸如eBay和Groupon等電子商務平台或亞馬遜網站上未經授權的第三方購買我們的腕錶，您可能會買到假冒、二手或者劣次品。若無法出示證明文件原件，Daniel Wellington 不提供任何保固。',
    legalP6: '如需詳細資訊及尋找所在地附近的授權經銷商，請訪問 www.danielwellington.com/authorized-retailers'
  },
  hu: {
    authorised: 'Mit jelent a hivatalos márkakereskedő elnevezés?',
    directions: 'Útvonaltervezés',
    continue: 'Vásárlás folytatása',
    listHeader: 'Üzlet megjelenítése a térképen',
    listHeaderMult: 'Üzletek megjelenítése a térképen',
    matrix: 'km',
    myPosition: 'Az én helyzetem',
    search: 'Keresés ország, állam, város, cím... alapján',
    closed: 'Zárva',
    showIpad: 'Mutasd a térképen',
    monFri: 'Hét - Pén',
    sat: 'Szo',
    sun: 'Vas',
    legalH1: 'HIVATALOS MÁRKAKERESKEDŐK',
    legalH2: 'MIÉRT VÁSÁROLJAK HIVATALOS MÁRKAKERESKEDŐTŐL?',
    legalL1: 'Ön eredeti Daniel Wellington órát vásárol',
    legalL2: 'Karórájára kiterjed a Daniel Wellington nemzetközi garanciája',
    legalL3: 'Mindennemű szerviz vagy javítási tevékenységet gyakorlott személyzet végez',
    legalL4: 'A legmagasabb szintű ügyfélszolgálatban lesz része',
    legalP1: 'A Daniel Wellington biztosítani szeretné, hogy Önnek a vásárlás előtt, alatt és után egyaránt a lehető legjobb tapasztalatai legyenek termékeinkkel kapcsolatosan. Világszerte kizárólag olyan partnerekkel dolgozunk, akik abban a kiváltságos helyzetben vannak, hogy a Daniel Wellington hivatalos márkakereskedői lehetnek.',
    legalP2: 'Akár kiskereskedelmi üzletben, akár online vásárol, azt szeretnénk, ha ez egy olyan élmény lenne az Ön számára, amellyel teljes mértékben elégedett. Kiskereskedelmi partnereink számunkra már bizonyították, hogy elkötelezettek a folyamatosan magas színvonalú szolgáltatás nyújtása iránt.',
    legalP3: 'Az egyetlen módja annak, hogy Ön eredeti Daniel Wellington órát vásároljon, ha azt egy hivatalos márkakereskedőn vagy a danielwellington.com weboldalon keresztül teszi.',
    legalP4: 'Ha Ön egy hivatalos Daniel Wellington márkakereskedőtől vásárol karórát, biztos lehet benne, hogy:',
    legalP5: 'Ha Ön olyan e-kereskedelmi platformokon vásárol, mint az eBay és a Groupon, vagy egy nem hivatalos harmadik fél beszállítótól az Amazonon, fennáll annak a kockázata, hogy hamis, használt vagy hibás órát kap. A Daniel Wellingtonnak nem áll módjában teljesíteni eredeti dokumentációval nem rendelkező jótállási igényeket.',
    legalP6: 'További információkért és az Ön lakhelyéhez közeli hivatalos forgalmazó vagy márkakereskedő megtalálásához kérjük, látogasson el a www.danielwellington.com/authorized-retailers weboldalra'
  },
  kr: {
    authorised: '공식판매처란?',
    directions: '주소 확인하기',
    continue: '계속 쇼핑하기',
    listHeader: '지도에 표시된 매장',
    listHeaderMult: '지도에 표시된 매장들',
    matrix: 'km',
    myPosition: '내 위치',
    search: '국가, 주, 시, 도, 주소, 우편번호로 검색',
    closed: '영업 종료',
    showIpad: '지도 보기',
    monFri: '월 - 금',
    sat: '토',
    sun: '일',
    legalH1: '공인 판매점',
    legalH2: '공인판매점에서구매해야하는이유',
    legalL1: '신뢰할 수 있는 정품 Daniel Wellington 제품을 구매하는 것입니다.',
    legalL2: 'Daniel Wellington의 국제 보증의 적용을 받습니다.',
    legalL3: '전문 기술자가 모든 서비스나 수리를 진행합니다.',
    legalL4: '가장 높은 수준의 고객 경험을 제공합니다.',
    legalP1: 'Daniel Wellington은 상품을 구매하기 전, 구매하는 동안 그리고 구매한 후에도 뛰어난 고객 경험을 제공하기 위해 모든 노력을 기울이고 있습니다. 이를 위해 전 세계에서 공인 Daniel Wellington 판매권을 획득한 선택된 파트너들과 긴밀하게 협력하고 있습니다.',
    legalP2: '소매 상점이나 온라인을 포함하여 어떤 공인 판매점에서 상품을 구매하든지 Daniel Wellington은 고객이 완전히 만족할 수 있는 경험을 전달해 드리기를 원합니다. Daniel Wellington의 소매 파트너들은 일관되고 탁월한 수준의 서비스를 전달하기 위해 헌신하고 있음을 시장에서 입증해 보여주었습니다.',
    legalP3: '정품 Daniel Wellington 시계를 확실하게 구매할 수 있는 유일한 방법은 공인 판매점이나 danielwellington.com을 통해 구매하는 것입니다.',
    legalP4: '공인 Daniel Wellington 판매점에서 시계를 구매하는 경우 다음과 같은 이점이 있습니다.',
    legalP5: 'Amazon, eBay 또는 Groupon과 같이 공인되지 않은 판매점에서 구매하는 경우 위조 제품, 중고 제품 또는 결함 제품을 받을 위험이 있습니다. Daniel Wellington은 원본 보증 문서에서 명시하지 않은 모든 보증 청구를 받아들이지 않습니다.',
    legalP6: '현지 공인 판매점이나 소매상에 대한 자세한 정보나 그 위치를 확인하려면 www.danielwellington.com/authorized-retailers를 방문하시기 바랍니다.'
  },
  kz_kk: {
    authorised: 'Өкілетті бөлшек сауда саудагері деген кім?',
    directions: 'Қалай жетуге болады',
    continue: 'Сауда жасауды жалғастыру',
    listHeader: 'Картада көрсетілген дүкен',
    listHeaderMult: 'Картада көрсетілген дүкендер',
    matrix: 'км',
    myPosition: 'Менің орным',
    search: 'Ел, штат, қала, мекенжай, пошталық индекс бойынша іздеу...',
    closed: 'Жабық',
    showIpad: 'Картада көрсету',
    monFri: 'Дүй - Жұм',
    sat: 'Сен',
    sun: 'Жек',
    legalH1: 'ӨКІЛЕТТІ БӨЛШЕК САУДА САУДАГЕРЛЕРІ',
    legalH2: 'НЕЛІКТЕН ӨКІЛЕТТІ БӨЛШЕК САУДА САУДАГЕРІНЕН САТЫП АЛУ КЕРЕК?',
    legalL1: 'Daniel Wellington түпнұсқалық сағатын сатып аласыз',
    legalL2: 'Сағатыңыз Daniel Wellington компаниясының халықаралық кепілдігімен қамтылады',
    legalL3: 'Кез келген қызмет көрсету немесе жөндеу жұмыстары тәжірибелі маманмен орындалады',
    legalL4: 'Сізге тұтынушылар қызметінің ең жоғары деңгейі көрсетіледі',
    legalP1: 'Daniel Wellington компаниясында біз сіздің сатып алғанға дейін, кезінде және кейін біздің өнімдерімізді пайдалану тәжірибеңіздің тамаша болғанын қалаймыз. Біз бүкіл әлем бойынша Daniel Wellington компаниясының өкілетті бөлшек сауда саудагері болудың айрықша құқығына лайықты болған серіктестердің таңдамалы тобымен ғана жұмыс істейміз.',
    legalP2: 'Бөлшек сауда дүкенінен болсын немесе онлайн режимде болсын, қайсысын сатып алсаңыз да, біз сіздің өнімге риза болғаныңызды қалаймыз. Біздің бөлшек саудамен айналысатын серіктестеріміз бізге қызмет көрсетудің әрқашан жоғары деңгейін қамтамасыз етуге ұмтылатындарын дәлелдеді.',
    legalP3: 'Daniel Wellington түпнұсқалық сағатын сатып алып жатқаныңызға көз жеткізудің жалғыз жолы – оны өкілетті бөлшек сауда саудагері арқылы немесе danielwellington.com сайтында сатып алу.',
    legalP4: 'Сағатты өкілетті Daniel Wellington бөлшек сауда саудагерінен сатып алу арқылы сіз келесілерге сенімді боласыз:',
    legalP5: 'Егер eBay және Groupon сияқты электронды коммерциялық платформалардан немесе Amazon платформасындағы авторизацияланбаған үшінші тарап жеткізушісінен сатып алсаңыз, онда жасанды, қолданылған немесе ақаулы сағатты алуы қаупі бар. Daniel Wellington компаниясы түпнұсқалық құжаттамамен бірге берілмеген қандай да бір кепілдік талаптарын орындамайды.',
    legalP6: 'Қосымша ақпарат алу және өз аймағыңыздағы өкілетті алып сатушыны немесе бөлшек сауда саудагерін табу үшін, www.danielwellington.com/authorized-retailers сайтына кіріңіз'
  },
  kz_ru: {
    authorised: 'Что такое уполномоченный розничный продавец?',
    directions: 'Узнать направление',
    continue: 'Продолжить покупки',
    listHeader: 'Магазин на карте',
    listHeaderMult: 'Магазины на карте',
    matrix: 'km',
    myPosition: 'МОЁ МЕСТОПОЛОЖЕНИЕ',
    search: 'Искать по стране, области, городу, адресу, индексу',
    closed: 'Закрыто',
    showIpad: 'Показать на карте',
    monFri: 'Понедельник-Пятница',
    sat: 'Суббота',
    sun: 'Воскресенье',
    legalH1: 'ОФИЦИАЛЬНЫЕ ДИСТРИБЬЮТОРЫ',
    legalH2: 'ПОЧЕМУ НЕОБХОДИМО ПОКУПАТЬ ИЗДЕЛИЯ DANIEL WELLINGTON У ОФИЦИАЛЬНЫХ ДИСТРИБЬЮТОРОВ?',
    legalL1: 'Вы покупаете настоящие часы бренда Daniel Wellington',
    legalL2: 'На ваши часы будет распространяться международная гарантия Daniel Wellington',
    legalL3: 'Все работы по сервисному обслуживанию и ремонту будут проводиться опытными специалистами',
    legalL4: 'Вам будет предоставлено обслуживание наивысшего качества',
    legalP1: 'Компания Daniel Wellington стремится к тому, чтобы ваши впечатления от нашей продукции были непревзойденными до, во время и после ее приобретения. Мы работаем только с группой избранных торговых партнеров по всему миру, которые заслужили право стать официальными дистрибьюторами продукции Daniel Wellington.',
    legalP2: 'Независимо от того, приобретаете вы часы в розничном магазине или интернет-магазине, мы хотим, чтобы ваши впечатления от нашего бренда всегда были на высоте. Наши партнеры по розничной торговле доказали нам, что стремятся предоставлять клиентам обслуживание неизменно высокого качества.',
    legalP3: 'Единственный способ удостовериться в том, что вы покупаете настоящие часы Daniel Wellington — приобрести их у официального дистрибьютора или на сайте danielwellington.com.',
    legalP4: 'Приобретая часы у официального дистрибьютора продукции Daniel Wellington, вы можете быть уверены в том, что:',
    legalP5: 'В случае покупки с платформ электронной коммерции, например, eBay и Groupon, или у неавторизованного стороннего продавца на Amazon, вы подвергаетесь риску получения поддельных, использованных или поврежденных часов. Компания Daniel Wellington не выполняет требования по исполнению гарантийных обязательств, не подкрепленные оригиналами соответствующей документации.',
    legalP6: 'Для получения дополнительной информации и поиска официальных дилеров или дистрибьюторов продукции Daniel Wellington в вашем регионе, пожалуйста, посетите сайт www.danielwellington.com/authorized-retailers'
  },
  no: {
    authorised: 'Hva er en autorisert forhandler?',
    directions: 'Få veibeskrivelse',
    continue: 'Fortsett å handle',
    listHeader: 'Forretning vist på kart',
    listHeaderMult: 'Forretninger vist på kart',
    matrix: 'km',
    myPosition: 'Min posisjon',
    search: 'Søk etter land, fylke, by, adresse, postnummer ...',
    closed: 'Stengt',
    showIpad: 'Vis på kart',
    monFri: 'Man - fre',
    sat: 'Lør',
    sun: 'Søn',
    legalH1: 'AUTORISERTE FORHANDLERE',
    legalH2: 'HVORFOR KJØPE FRA EN AUTORISERT FORHANDLER?',
    legalL1: 'Du kjøper en autentisk Daniel Wellington-klokke',
    legalL2: 'Klokken din vil bli dekket av Daniel Wellingtons internasjonale garanti',
    legalL3: 'Service eller reparasjon vil bli utført av erfarent personale',
    legalL4: 'Du vil oppleve den høyeste grad av kundeservice',
    legalP1: 'Hos Daniel Wellington ønsker vi å sikre at din opplevelse med produktene våre er enestående, før, under og etter kjøpet. Vi arbeider utelukkende med en utvalgt gruppe partnere rundt om i verden som har fortjent det privilegium det er å være en autorisert Daniel Wellington-forhandler.',
    legalP2: 'Enten du kjøper fra en butikk eller på nettet, vil vi at du skal få en opplevelse som gjør deg absolutt fornøyd. Våre forhandlere har bevist for oss at de er opptatt av å levere en gjennomgående fremragende service.',
    legalP3: 'Den eneste måten å sikre at du kjøper en autentisk Daniel Wellington-klokke er å kjøpe den gjennom en autorisert forhandler eller på danielwellington.com.',
    legalP4: 'Når du kjøper en klokke fra en autorisert forhandler av Daniel Wellington kan du være sikker på at:',
    legalP5: 'Hvis du kjøper fra en e-handelsplattform så som eBay og Groupon, eller en ikke-autorisert, tredjeparts selger på Amazon, er det en mulighet for at du får en klokke som er falsk, brukt eller defekt. Daniel Wellington respekterer ikke eventuelle garantikrav som ikke er ledsaget av den opprinnelige dokumentasjonen.',
    legalP6: 'For mer informasjon, og for å finne en autorisert forhandler i ditt område, vennligst besøk www.danielwellington.com/authorized-retailers'
  },
  nl: {
    authorised: 'Wat is een geautoriseerde dealer?',
    directions: 'Routebeschrijving',
    continue: 'Verder winkelen',
    listHeader: 'Winkel op de kaart',
    listHeaderMult: 'Winkels op de kaart',
    matrix: 'km',
    myPosition: 'Mijn locatie',
    search: 'Zoek op land, provincie, plaats, adres, postcode, …',
    closed: 'Gesloten',
    showIpad: 'Weergeven op kaart',
    monFri: 'ma - vrij',
    sat: 'zat',
    sun: 'zon',
    legalH1: 'GEAUTORISEERDE DEALERS',
    legalH2: 'WAAROM KOPEN BIJ EEN GEAUTORISEERDE DEALER?',
    legalL1: 'U koopt een origineel Daniel Wellington-horloge',
    legalL2: 'Uw horloge wordt gedekt door de internationale garantie van Daniel Wellington',
    legalL3: 'Onderhoud of reparatie wordt door ervaren medewerkers uitgevoerd',
    legalL4: 'U geniet van het hoogste niveau aan klantenservice',
    legalP1: 'Bij Daniel Wellington willen we ervoor zorgen dat u een uitstekende ervaring hebt met onze producten voor, tijdens en na uw aankoop. We werken exclusief met een selecte groep partners over de hele wereld die het privilege verdiend hebben een geautoriseerde dealer van Daniel Wellington te worden.',
    legalP2: 'Of u nu bij een winkel of online koopt, wij willen dat u een ervaring hebt die niets te wensen overlaat. Onze retailpartners hebben aan ons bewezen dat ze zich toeleggen op het leveren van een consistent uitstekend serviceniveau.',
    legalP3: 'De enige manier om te zorgen dat u een origineel Daniel Wellington-horloge koopt, is via een geautoriseerde dealer of via danielwellington.com.',
    legalP4: 'Wanneer u een horloge koopt bij een geautoriseerde dealer van Daniel Wellington, weet u het volgende zeker:',
    legalP5: 'Als je koopt op e-commerce platforms zoals eBay en Groupon of bij een niet-gemachtigde derde verkoper op Amazon, loop je het risico dat het horloge namaak, gebruikt of defect is. Daniel Wellington gaat niet in op garantieclaims die niet vergezeld gaan van de originele documentatie.',
    legalP6: 'Voor meer informatie en om een geautoriseerde dealer in uw regio te zoeken, gaat u naar www.danielwellington.com/authorized-retailers'
  },
  pl: {
    authorised: 'Kto to jest Autoryzowany sprzedawca?',
    directions: 'Jak trafić?',
    continue: 'Kontynuuj zakupy',
    listHeader: 'Sklep widoczny na mapie',
    listHeaderMult: 'Sklepy widoczne na mapie',
    matrix: 'km',
    myPosition: 'Moja pozycja',
    search: 'Szukaj wg kraju, województwa, miasta, adresu, kodu pocztowego...',
    closed: 'Zamknięte',
    showIpad: 'Pokaż na mapie',
    monFri: 'Pon. - Pt.',
    sat: 'Pon. - Pt.',
    sun: 'Ndz.',
    legalH1: 'AUTORYZOWANI SPRZEDAWCY',
    legalH2: 'DLACZEGO WARTO KUPOWAĆ U AUTORYZOWANEGO SPRZEDAWCY?',
    legalL1: 'zyskuje się pewność, że jest to oryginalny zegarek Daniel Wellington',
    legalL2: 'zakupiony zegarek będzie objęty międzynarodową gwarancją Daniel Wellington',
    legalL3: 'konserwacja lub naprawy zegarka będą przeprowadzane przez doświadczonych specjalistów',
    legalL4: 'można być pewnym najwyższego poziomu obsługi klienta',
    legalP1: 'Daniel Wellington dokłada wszelkich starań, aby wszystko, co dotyczy naszych produktów, przekraczało oczekiwania naszych klientów – przed zakupem, w jego trakcie, a także już po jego dokonaniu. Współpracujemy wyłącznie ze starannie wybranymi partnerami na całym świecie. Każdy z nich uzyskał tytuł autoryzowanego sprzedawcy Daniel Wellington.',
    legalP2: 'Pragniemy, aby nasi klienci byli w pełni zadowoleni z zakupu, niezależnie od tego, czy dokonują go w sklepie stacjonarnym, czy internetowym. Nasi partnerzy handlowi wyraźnie udowodnili nam, że dokładają wszelkich starań, aby nieprzerwanie dostarczać usługi na jak najwyższym poziomie.',
    legalP3: 'Aby mieć pewność, że posiadany zegarek Daniel Wellington jest oryginalny, wystarczy dokonać zakupu u autoryzowanego sprzedawcy lub na stronie internetowej danielwellington.com.',
    legalP4: 'Kupując zegarek od autoryzowanego sprzedawcy Daniel Wellington:',
    legalP5: 'Robiąc zakupy na platformach handlu elektronicznego, takich jak eBay i Groupon, lub u nieautoryzowanych sprzedawców zewnętrznych obecnych w serwisie Amazon, istnieje ryzyko otrzymania podrobionego, używanego lub uszkodzonego zegarka. Daniel Wellington nie honoruje roszczeń gwarancyjnych w stosunku do produktów, które nie posiadają oryginalnej dokumentacji.',
    legalP6: 'Aby uzyskać więcej informacji i znaleźć najbliższego autoryzowanego sprzedawcę, wystarczy odwiedzić stronę internetową: www.danielwellington.com/authorized-retailers'
  },
  pt: {
    authorised: 'O que é um revendedor autorizado?',
    directions: 'Obter endereços',
    continue: 'Continuar a comprar',
    listHeader: 'Loja mostrada no mapa',
    listHeaderMult: 'Lojas mostradas no mapa',
    matrix: 'km',
    myPosition: 'A minha posição',
    search: 'Pesquisar por país, estado, cidade, endereço, código postal...',
    closed: 'Fechado',
    showIpad: 'Mostrar no mapa',
    monFri: 'Seg. - Sex.',
    sat: 'Sab.',
    sun: 'Dom.',
    legalH1: 'REVENDEDORES AUTORIZADOS',
    legalH2: 'PORQUÊ COMPRAR A UM REVENDEDOR AUTORIZADO?',
    legalL1: 'Está a comprar um relógio autêntico Daniel Wellington',
    legalL2: 'O seu relógio estará coberto pela garantia internacional Daniel Wellington',
    legalL3: 'Qualquer assistência ou reparação será realizada por pessoal experiente',
    legalL4: 'Irá beneficiar do mais elevado nível de assistência ao cliente',
    legalP1: 'Na Daniel Wellington queremos garantir-lhe uma experiência excecional com os nossos produtos, antes, durante e depois da sua compra. Trabalhamos exclusivamente com um grupo de parceiros selecionados no mundo inteiro que conquistaram o privilégio de serem agentes autorizados da Daniel Wellington.',
    legalP2: 'Quer efetue a sua compra numa loja de retalho ou online, queremos que essa sua experiência o deixe completamente satisfeito. Os nossos parceiros retalhistas deram-nos provas de que estão empenhados em desenvolver um nível de serviço de excelência permanente.',
    legalP3: 'A única forma de assegurar que está a comprar um relógio Daniel Wellington autêntico é comprá-lo através de um revendedor autorizado ou em danielwellington.com.',
    legalP4: 'Quando compra um relógio a um revendedor Daniel Wellington, pode ter a certeza de que:',
    legalP5: 'Ao comprar em plataformas de ecommerce como o eBay e o Groupon ou através de outros fornecedores não autorizados na Amazon, correrá o risco de receber um relógio falsificado, usado ou com defeito. A Daniel Wellington não aceita quaisquer reclamações de garantia que não sejam acompanhadas pela documentação original.',
    legalP6: 'Para obter mais informações e encontrar um revendedor autorizado na sua área, visite www.danielwellington.com/authorized-retailers'
  },
  ro: {
    authorised: 'Ce este un retailer autorizat?',
    directions: 'Obțineți îndrumări',
    continue: 'Continuați cumpărăturile',
    listHeader: 'Magazin prezentat pe hartă',
    listHeaderMult: 'Magazine prezentate pe hartă',
    matrix: 'km',
    myPosition: 'Poziția mea',
    search: 'Căutare după țară, stat, oraș, adresă, cod poștal ...',
    closed: 'Închis',
    showIpad: 'Prezentare pe hartă',
    monFri: 'Luni - Vineri',
    sat: 'Sâm',
    sun: 'Dum',
    legalH1: 'RETAILERI AUTORIZAȚI',
    legalH2: 'DE CE SĂ CUMPĂRAȚI DE LA UN RETAILER AUTORIZAT?',
    legalL1: 'Cumpărați un ceas autentic Daniel Wellington',
    legalL2: 'Ceasul dumneavoastră va fi acoperit de garanția internațională Daniel Wellington',
    legalL3: 'Orice lucrări de service sau reparații vor fi realizate de către personal experimentat',
    legalL4: 'Vă veți bucura de cel mai înalt nivel al serviciilor pentru clienți',
    legalP1: 'Noi, cei de la Daniel Wellington, dorim să ne asigurăm că experiența dumneavoastră cu produsele noastre este excepțională, înainte, în timpul și după achiziție. Noi lucrăm exclusiv cu un grup selecționat de parteneri din întreaga lume, care și-au câștigat privilegiul de a fi retaileri autorizați Daniel Wellington.',
    legalP2: 'Fie că achiziționați dintr-un magazin de vânzare cu amănuntul sau online, dorim să vă bucurați de o experiență care să vă satisfacă în totalitate. Partenerii noștri de retail ne-au dovedit că sunt angajați în furnizarea consecventă a unui nivel excelent de servicii.',
    legalP3: 'Unicul mod prin care vă asigurați de achiziționarea unui ceas autentic Daniel Wellington este de a-l cumpăra prin intermediul unui retailer autorizat sau de la danielwellington.com.',
    legalP4: 'Când achiziționați un ceas de la un retailer autorizat Daniel Wellington, puteți fi siguri că:',
    legalP5: 'În cazul în care achiziționați de pe platforme de comerț electronic, de exemplu eBay și Groupon sau de la un distribuitor neautorizat de terță parte de pe Amazon, există riscul de a primi un ceas contrafăcut, folosit sau defect. Daniel Wellington nu onorează nicio cerere de garanție care nu este însoțită de documentația originală.',
    legalP6: 'Pentru informații suplimentare și pentru a găsi un distribuitor sau retailer autorizat din zona dumneavoastră, vă rugăm să consultați www.danielwellington.com/authorized-retailers'
  },
  ru: {
    authorised: 'Что такое уполномоченный розничный продавец?',
    directions: 'Узнать направление',
    continue: 'Продолжить покупки',
    listHeader: 'Магазин на карте',
    listHeaderMult: 'Магазины на карте',
    matrix: 'km',
    myPosition: 'МОЁ МЕСТОПОЛОЖЕНИЕ',
    search: 'Искать по стране, области, городу, адресу, индексу',
    closed: 'Закрыто',
    showIpad: 'Показать на карте',
    monFri: 'Понедельник-Пятница',
    sat: 'Суббота',
    sun: 'Воскресенье',
    legalH1: 'ОФИЦИАЛЬНЫЕ ДИСТРИБЬЮТОРЫ',
    legalH2: 'ПОЧЕМУ НЕОБХОДИМО ПОКУПАТЬ ИЗДЕЛИЯ DANIEL WELLINGTON У ОФИЦИАЛЬНЫХ ДИСТРИБЬЮТОРОВ?',
    legalL1: 'Вы покупаете настоящие часы бренда Daniel Wellington',
    legalL2: 'На ваши часы будет распространяться международная гарантия Daniel Wellington',
    legalL3: 'Все работы по сервисному обслуживанию и ремонту будут проводиться опытными специалистами',
    legalL4: 'Вам будет предоставлено обслуживание наивысшего качества',
    legalP1: 'Компания Daniel Wellington стремится к тому, чтобы ваши впечатления от нашей продукции были непревзойденными до, во время и после ее приобретения. Мы работаем только с группой избранных торговых партнеров по всему миру, которые заслужили право стать официальными дистрибьюторами продукции Daniel Wellington.',
    legalP2: 'Независимо от того, приобретаете вы часы в розничном магазине или интернет-магазине, мы хотим, чтобы ваши впечатления от нашего бренда всегда были на высоте. Наши партнеры по розничной торговле доказали нам, что стремятся предоставлять клиентам обслуживание неизменно высокого качества.',
    legalP3: 'Единственный способ удостовериться в том, что вы покупаете настоящие часы Daniel Wellington — приобрести их у официального дистрибьютора или на сайте danielwellington.com.',
    legalP4: 'Приобретая часы у официального дистрибьютора продукции Daniel Wellington, вы можете быть уверены в том, что:',
    legalP5: 'В случае покупки с платформ электронной коммерции, например, eBay и Groupon, или у неавторизованного стороннего продавца на Amazon, вы подвергаетесь риску получения поддельных, использованных или поврежденных часов. Компания Daniel Wellington не выполняет требования по исполнению гарантийных обязательств, не подкрепленные оригиналами соответствующей документации.',
    legalP6: 'Для получения дополнительной информации и поиска официальных дилеров или дистрибьюторов продукции Daniel Wellington в вашем регионе, пожалуйста, посетите сайт www.danielwellington.com/authorized-retailers'
  },
  sa_ar: {
    authorised: 'من هو تاجر التجزئة المعتمد؟',
    directions: 'احصل على التوجيهات',
    continue: 'متابعة التسوّق',
    listHeader: 'المتجر المعروض على الخريطة',
    listHeaderMult: 'المتاجر المعروضة على الخريطة',
    matrix: 'km',
    myPosition: 'الموضع الخاص بي',
    search: 'البحث باستخدام الدولة، الولاية، المدينة، العنوان، الرمز البريدي...',
    closed: 'مغلق',
    showIpad: 'معروض على الخريطة',
    monFri: 'الاثنين - الجمعة',
    sat: 'السبت',
    sun: 'الأحد',
    legalH1: 'باعة التجزئة المُعتمدون لـ «دانيال ولينغتون',
    legalH2: 'لماذا الشراء من بائع تجزئة مُعتمد؟',
    legalL1: 'لكونك تشتري ساعة «دانيال ولينغتون» أصليّة',
    legalL2: 'أن ساعتك ستكون مُغطّاة بكفالة «دانيال ولينغتون» العالميّة',
    legalL3: 'أن أي خدمة أو صيانة ستُنجز من قبل طاقم من العاملين ذوي الخبرة',
    legalL4: 'أنك ستتلقّى خدمة زبائن على أعلى مستوى',
    legalP1: 'في «دانيال ولينغتون»، نودّ ضمان أن تكون تجربتك مع منتجاتنا تجربة متميزة قبل، وأثناء، وبعد عملية الشراء. نحن نعمل بشكلٍ حصري مع مجموعة مُختارة من الشركاء في مختلف أنحاء العالم ممّن قد نالوا امتياز كونهم بائعي تجزئة معتمدين لـ «دانيال ولينغتون».',
    legalP2: 'سواءً كنت تشتري من أحد متاجر البيع بالتجزئة أو عبر شبكة الإنترنت، نريدك أن تحظى بتجربة تتركك راضٍ تماما. وقد أثبت شركاؤنا في البيع بالتجزئة أنهم مُلتزمون بتقديم مستوى خدمة ممتاز بشكلٍ ثابت.',
    legalP3: 'إن الطريقة الوحيدة لتضمن أنك تشتري ساعة «دانيال ولينغتون» أصليّة هي أن تقوم بشرائها من أحد باعة التجزئة المُعتمدين أو من خلال danielwellington.com',
    legalP4: 'عند شرائك ساعة من أحد باعة التجزئة المُعتمدين لـ «دانيال ولينغتون»، يمكنك الاطمئنان:',
    legalP5: 'في حال الشراء من أحد الباعة غير الممُعتمدين، مثل «أمازون» و«إيباي» و«غروبون»، ثمّة مجازفة باستلام ساعة مُزيّفة أو مُستعملة أو معيبة. لا تقبل «دانيال ولينغتون» أي طلبات كفالة غير مُرفقة بالوثائق الأصليّة.',
    legalP6: 'للمزيد من المعلومات ولإيجاد وكيل أو بائع تجزئة مُعتمد في منطقتك، يرجى زيارة www.danielwellington.com/authorized-retailers'
  },
  se: {
    authorised: 'Vad är en auktoriserad återförsäljare?',
    directions: 'Hämta väganvisning',
    continue: 'Fortsätt shoppa',
    listHeader: 'Butik visas på kartan',
    listHeaderMult: 'Butiker visas på kartan',
    matrix: 'km',
    myPosition: 'Min position',
    search: 'Sök på land, region, stad, adress, postadress ...',
    closed: 'Stängt',
    showIpad: 'Visa på karta',
    monFri: 'Mån - Fre',
    sat: 'Lör',
    sun: 'Sön',
    legalH1: 'AUKTORISERAD ÅTERFÖRSÄLJARE',
    legalH2: 'VARFÖR HANDLA HOS EN AUKTORISERAD ÅTERFÖRSÄLJARE?',
    legalL1: 'Du köper en autentiskt klocka från Daniel Wellington',
    legalL2: 'Du får Daniel Wellingtons världsomspännande garanti',
    legalL3: 'All service och alla reparationer utförs av erfaren personal',
    legalL4: 'Du får uppleva en förstklassig kundtjänst',
    legalP1: 'Vi på Daniel Wellington vill att du får en överlägsen upplevelse av våra produkter både före, under och efter ditt köp. Vi arbetar exklusivt med ett urval av partners över hela världen, som har förtjänat privilegiet att vara auktoriserade återförsäljare för Daniel Wellington.',
    legalP2: 'Oavsett om du handlar i butik eller online vill vi att du alltid är nöjd med din upplevelse, och våra återförsäljare har visat oss att de inte nöjer sig med något annat än en förstklassig service.',
    legalP3: 'Det enda sättet för dig att få en garanti för att du har köpt en autentisk Daniel Wellington-klocka är att köpa den hos en auktoriserad återförsäljare eller på danielwellington.com.',
    legalP4: 'När du köper en klocka av en auktoriserad Daniel Wellington-återförsäljare får du en garanti för att:',
    legalP5: 'Om du handlar från e-handelsplattformar som eBay och Groupon eller en oauktoriserad tredjepartsleverantör på Amazon så riskerar du att få en klocka som är begagnad, innehåller defekter eller är en kopia. Daniel Wellington tar inte emot garantireklamationer som inte åtföljs av originaldokumentet.',
    legalP6: ''
  },
  sk: {
    authorised: 'Aký je autorizovaný predajca?',
    directions: 'Získať informácie o trase',
    continue: 'Pokračovať v nákupe',
    listHeader: 'Ukázať obchod na mape',
    listHeaderMult: 'Obchody zobrazené na mape',
    matrix: 'km',
    myPosition: 'Moja pozícia',
    search: 'Hľadať podľa krajiny, štátu, mesta, adresy, PSČ... ',
    closed: 'Zatvorené',
    showIpad: 'Ukázať na mape',
    monFri: 'Pondelok – piatok',
    sat: 'Sobota',
    sun: 'Nedeľa',
    legalH1: 'AUTORIZOVANÍ MALOOBCHODNÍ PREDAJCOVIA',
    legalH2: 'PREČO NAKUPOVAŤ OD AUTORIZOVANÉHO PREDAJCU?',
    legalL1: 'Kupujete originálne hodinky Daniel Wellington',
    legalL2: 'Vaše hodinky budú kryté medzinárodnou zárukou spoločnosti Daniel Wellington',
    legalL3: 'Všetky služby a opravy vykonávajú skúsení odborníci',
    legalL4: 'Máte k dispozícii zákaznícky servis na najvyššej úrovni',
    legalP1: 'V spoločnosti Daniel Wellington chceme zabezpečiť, aby vaše skúsenosti s našimi produktmi boli vynikajúce pred ich kúpou, počas nej a aj po nej. Pracujeme exkluzívne so skupinou vybraných partnerov z celého sveta, ktorí získali privilegované postavenie autorizovaného maloobchodného predajcu značky Daniel Wellington.',
    legalP2: 'Či už nakupujete v maloobchodnej predajni, alebo online, chceme vám poskytnúť zážitok absolútnej spokojnosti. Naši maloobchodní partneri nám dokázali, že sú odhodlaní poskytovať trvale vynikajúcu úroveň služieb.',
    legalP3: 'Jediný istý spôsob, ako si kúpiť originálne hodinky Daniel Wellington, je ich kúpa cez autorizovaného predajcu alebo na stránke danielwellington.com.',
    legalP4: 'Pokiaľ si hodinky kúpite od autorizovaného predajcu Daniel Wellington, máte istotu, že:',
    legalP5: 'Keď nakupujete na internetových platformách, ako je eBay a Groupon, alebo od neautorizovaného predajcu tretej strany na platforme Amazon, hrozí, že dostanete falošné, použité alebo pokazené hodinky. Daniel Wellington neuznáva nároky na záruku, ku ktorým nie je predložená originálna dokumentácia.',
    legalP6: 'Bližšie informácie a rady, ako nájsť autorizovaného predajcu vo svojej blízkosti, nájdete na stránke www.danielwellington.com/autorizovani-predajcovia'
  },
  th: {
    authorised: 'ผู้ค้าปลีกที่ได้รับอนุญาตคืออะไร',
    directions: 'หาข้อมูลบอกทิศทาง',
    continue: 'ซื้อสินค้าต่อ',
    listHeader: 'ร้านค้าที่ปรากฏบนแผนที่',
    listHeaderMult: 'ร้านค้าที่ปรากฏบนแผนที่',
    matrix: 'km',
    myPosition: 'ตำแหน่งที่ตั้งของฉัน',
    search: 'ค้นหาตามชื่อประเทศ, รัฐ, เมือง/จังหวัด, ที่อยู่, รหัสไปรษณีย์…',
    closed: 'ปิด',
    showIpad: 'แสดงบนแผนที่',
    monFri: 'จันทร์ - ศุกร์',
    sat: 'เสาร์',
    sun: 'อาทิตย์',
  },
  tr: {
    authorised: 'Yetkili perakende satıcı nedir?',
    directions: 'Yol tarifi alın',
    continue: 'Alışverişe devam edin',
    listHeader: 'Haritada gösterilen mağaza',
    listHeaderMult: 'Haritada gösterilen mağazalar',
    matrix: 'km',
    myPosition: 'Pozisyonum',
    search: 'Ülke, eyalet, şehir, adres, posta kodu ile arama yapın ...',
    closed: 'Kapalı',
    showIpad: 'Haritada göster',
    monFri: 'Pazartesi - Cuma',
    sat: 'Cumartesi',
    sun: 'Pazar',
    legalH1: 'Yetkili Bayiler',
    legalH2: 'Niçin bir yetkili bayiden satın almalısınız?',
    legalL1: 'Orijinal bir Daniel Wellington saat satın alıyorsunuz',
    legalL2: 'Saatiniz Daniel Wellington uluslararası garanti kapsamında yer alıyor',
    legalL3: 'Her türlü servis veya tamir işlemi, deneyimli personel tarafından yerine getirilecek',
    legalL4: 'En üst düzey müşteri hizmeti deneyimini yaşayacaksınız',
    legalP1: 'Daniel Wellington\'da ürünlerimizle yaşadığınız deneyimin satın almanız öncesinde, sırasında ve sonrasında mükemmel olduğundan emin olmak istiyoruz. Dünya çapında Daniel Wellington yetkili bayisi olma ayrıcalığına erişmiş seçkin bir ortaklar grubuyla birlikte özel olarak çalışmaktayız.',
    legalP2: 'Gerek bir perakende satış mağazasından gerekse internetten satın almış olun, sizi tamamen memnun edecek bir deneyim yaşamanızı istiyoruz. Perakende ortaklarımız, bizlere sürekli mükemmel seviyede bir deneyim sunacaklarına kendilerini adamış oldukları hususuna bizlere kanıtlamış bulunmaktadır.',
    legalP3: 'Orijinal bir Daniel Wellington saat aldığınıza emin olmanızın tek yolu, o ürünü ya bir yetkili bayiden ya da danielwellington.com internet sitesinden satın almaktır.',
    legalP4: 'Yetkili bir Daniel Wellington bayisinden bir saat satın aldığınız zaman emin olabilirsiniz ki:',
    legalP5: 'Ürünlerimizi eBay ve Groupon gibi e-ticaret platformlarından veyaAmazon\'da yetkisiz bir üçüncü parti satıcıdan satın almanız durumunda size sahte, kullanılmış ya da kusurlu bir saatin ulaşması riski mevcuttur. Daniel Wellington, orijinal garanti belgesi eşliğinde iletilmeksizin hiçbir garanti kapsamında işlem talebine itibar etmemektedir.',
    legalP6: 'Daha detaylı bilgi edinmek ve size en yakın yetkili bayiyi veya perakende satıcıyı bulmak için lütfen web sitemizi ziyaret edin: www.danielwellington.com/storelocator'
  },
  ua: {
    authorised: 'Що таке авторизирований ретейлер?',
    directions: 'Отримати напрямки',
    continue: 'Продовжити покупки',
    listHeader: 'Магазин на карті',
    listHeaderMult: 'Магазини на карті',
    matrix: 'км',
    myPosition: 'Моє розташування',
    search: 'Пошук за країною, штатом, містом, адресою, поштовим індексом тощо ...',
    closed: 'Закрито',
    showIpad: 'Показати на карті',
    monFri: 'З понеділка по п\'ятницю',
    sat: 'Суббота',
    sun: 'Неділя',
    legalH1: 'АВТОРИЗОВАНІ РЕТЕЙЛЕРИ',
    legalH2: 'НАВІЩО КУПУВАТИ В АВТОРИЗОВАНИХ РЕТЕЙЛЕРІВ?',
    legalL1: 'Ви купуєте справжній годинник Daniel Wellington',
    legalL2: 'На ваш годинник від Daniel Wellington поширюється міжнародна гарантія',
    legalL3: 'Будь-яке обслуговування або ремонт буде проводитися досвідченим персоналом',
    legalL4: 'Вам буде надано найвищий рівень обслуговування',
    legalP1: 'У Daniel Wellington ми піклуємося про те, щоб ваш досвід із нашими товарами був бездоганний до, під час та після здійснення покупки. Ми працюємо виключно з вибраною групою партнерів по всьому світі, які отримали привілей бути авторизованими ретейлерами Daniel Wellington.',
    legalP2: 'Чи здійснили ви покупку в магазині або онлайн, ми хочемо, щоб ви залишилися повністю задоволеними. Наші ретейлери довели, що вони налаштовані забезпечувати постійний відмінний рівень послуг.',
    legalP3: 'Єдиний спосіб бути впевненим, що ви купуєте справжній годинник Daniel Wellington, — це здійснення покупки в авторизованого ретейлера або на сайті danielwellington.com.',
    legalP4: 'Купуючи годинник Daniel Wellington в авторизованого ретейлера, ви можете бути впевнені в наступному.',
    legalP5: 'Якщо покупка здійснюється на таких інтернет-платформах, як eBay і Groupon, або в неавторизованої третьої сторони на Amazon, існує ризик отримати підробний, уживаний або несправний годинник. Daniel Wellington не приймає претензій щодо гарантії, якщо вона не підкріплена оригінальними документами.',
    legalP6: 'Докладніше про те, як знайти авторизованого дилера або ретейлера у вашій місцевості, дивіться на сайті: www.danielwellington.com/authorized-retailers'
  },
  vn: {
    authorised: 'Đại lý bán lẻ được ủy quyền là gì?',
    directions: 'Tải hướng dẫn',
    continue: 'Tiếp tục mua sắm',
    listHeader: 'Cửa hàng hiển thị trên bản đồ',
    listHeaderMult: 'Các cửa hàng hiển thị trên bản đồ',
    matrix: 'km',
    myPosition: 'Vị trí của tôi',
    search: 'Tìm kiếm theo quốc gia, bang, thành phố, địa chỉ, mã zip…',
    closed: 'Đóng',
    showIpad: 'Hiển thị trên bản đồ',
    monFri: 'Thứ Hai - Thứ Sáu',
    sat: 'Thứ Bảy',
    sun: 'Chủ Nhật',
  }
}



//////////////////
// WEBPACK FOOTER
// ./localizations/locales.js
// module id = 142
// module chunks = 1